import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Car, ChevronRight } from 'lucide-react';
import { uploadsAPI } from '../services/api';
import { getRecentVehicles, RECENT_VEHICLES_EVENT } from '../services/recentVehiclesStore';

const toPath = (url) => { try { return new URL(url, window.location.origin).pathname; } catch { return '/vehicules'; } };

// Mobile menu block: last vehicle models viewed, reachable from any page
const MobileRecentVehicles = ({ onNavigate }) => {
  const [items, setItems] = useState(getRecentVehicles);
  useEffect(() => {
    const refresh = () => setItems(getRecentVehicles());
    window.addEventListener(RECENT_VEHICLES_EVENT, refresh);
    return () => window.removeEventListener(RECENT_VEHICLES_EVENT, refresh);
  }, []);
  if (!items.length) return null;
  return (
    <div className="py-2" data-testid="mobile-recent-vehicles">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 flex items-center gap-1.5 mb-1"><Car size={12} className="text-orange-500" /> Vos derniers véhicules</p>
      {items.slice(0, 4).map((v) => (
        <Link key={v.src} to={toPath(v.url)} onClick={onNavigate} data-testid={`mobile-recent-vehicle-${v.alt}`} className="flex items-center gap-3 py-1.5 pl-1 text-sm text-gray-800 hover:text-orange-600">
          <img src={uploadsAPI.resolveUrl(v.src)} alt="" loading="lazy" className="no-placeholder h-8 w-12 object-contain shrink-0" />
          <span className="flex-1 truncate">{v.alt}</span>
          <ChevronRight size={14} className="text-gray-400" />
        </Link>
      ))}
    </div>
  );
};

export default MobileRecentVehicles;
